import React, { FC } from 'react';

import { useHistory, useLocation, Redirect } from 'react-router-dom';

import { Loader } from '../../components/Loader';
import { LearnerInfo } from '../../types';
import { useAuth } from '../../utils/hooks';
import useQueryParams from '../../utils/hooks/useQueryParams';

interface LoginPageProps {
  userInfo: LearnerInfo;
  userLoading: boolean;
}

const LoginPage: FC<LoginPageProps> = ({ userInfo, userLoading }) => {
  const history = useHistory();
  const location = useLocation();
  const { loginWithRedirect, isInitialized, isLoading } = useAuth();
  const params = useQueryParams();

  if(!(!isInitialized || isLoading || userLoading)){
    if (!userLoading && userInfo) {
      if(params?.redirectUrl){
        history.replace(params.redirectUrl);
      }else{
        history.replace('/home');
      }
    } else {
      const hasPrevUrl = history.location?.state?.prevPath && history.location.state.prevPath !== '/';
      const redirectUrl = hasPrevUrl
        ? `${history.location.state.prevPath}${history.location.state.prevSearch || ''}`
        : '/home';
      const hasParamRedirect = Boolean(params?.redirectUrl);

      //check to prevent usual login via /sso
      if(location?.pathname && location.pathname.match(/^\/sso/) && !params?.connection){
        return <Redirect to="/" />;
      }else{
        loginWithRedirect({
          redirectUri: hasParamRedirect ? params.redirectUrl as string : redirectUrl,
          isDirectUrl: !(hasPrevUrl || hasParamRedirect),
          ...(params?.connection && typeof params.connection === 'string' && { connection: params.connection }),
          ...(params?.courseId && {
            appState: {
              onlineContentConnectorData: {
                userGuid: params?.userGuid,
                sessionToken: params?.sessionToken,
                callbackUrl: params?.callbackUrl,
                fqdn: params?.fqdn,
                subdomain: params?.subdomain,
                registrationNumber: params?.registrationNumber,
              },
            },
          }),
        });
      }
    }
  }

  return <Loader />;
};

export default LoginPage;
